import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { LinearProgress, Grid } from '@mui/material';
import config from '../config.json';
const localizer = momentLocalizer(moment);

function EventDetailsPopup({ event, onJoinEvent, mobileView }) {
    return (
        <div className="event-details-popup">
            <img src={event.imageUrl} alt={'event logo'} style={{ maxHeight: mobileView ? '50vh' : '70vh', maxWidth: mobileView ? '80vw' : '70vw' }} />
            <h2>{event.title}</h2>
            <p>{event.description}</p>
            <Grid container justifyContent="center" spacing={1}>
                <Grid item>
                    <button onClick={() => onJoinEvent(event.EventId)} style={{ background: config[process.env.REACT_APP_HOST_NAME].css.buttonColor }}>Join Event</button>
                </Grid>
                <Grid item>
                    <button onClick={() => onJoinEvent(false)} style={{ background: config[process.env.REACT_APP_HOST_NAME].css.buttonColor }}>Close</button>
                </Grid>
            </Grid>
        </div>
    );
}

const EventCalendar = () => {

    const [state, setState] = useState({
        mobileView: false,
        drawerOpen: false,
    });
    const { mobileView } = state;
    const [events, setEvents] = useState([]);
    const [isLoading, setisLoading] = useState(true);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [calendarViews, setCalendarViews] = useState(['month']);

    const eventStyleGetter = (event, start, end, isSelected) => {
        const backgroundColor = event.color ? event.color : config[process.env.REACT_APP_HOST_NAME].css.websiteColor;
        const style = {
            backgroundColor,
            borderRadius: "0px",
            opacity: 0.8,
            color: "white",
            border: "0px",
            display: "block",
            whiteSpace: "normal",
            wordWrap: "break-word",
            height: "auto" // or a fixed height, e.g. "60px"
        };
        return {
            style,
        };
    };


    const handleSelectEvent = (event) => {
        setSelectedEvent(event);
    };

    const handleJoinEvent = (event) => {
        // Perform action to join the event
        // ...
        // Close the popup
        if (event) {
            window.location.href = `/event/${event}`
        }
        setSelectedEvent(null);
    };

    useEffect(() => {
        const setResponsiveness = () => {
            if (window.innerWidth < 900) {
                setState((prevState) => ({ ...prevState, mobileView: true }));
            } else {
                setState((prevState) => ({ ...prevState, mobileView: false }));
                setCalendarViews([...calendarViews, 'week']);
            }
        };
        //getting programs
        let endPoint1 = `/api/events/list/view`
        //process.env.REACT_APP_API_URL
        fetch(process.env.REACT_APP_API_URL + endPoint1, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            },
        })
            .then((res) => res.json())
            .then((data) => {
                let resp = data.response.response_data
                let newArray = resp.slice(0, resp.length - 1)
                const newArrayOfObj = newArray.map(({
                    imageUrl,
                    StartDate,
                    EventName,
                    EndDate,
                    EventDescription,
                    ...rest
                }) => ({
                    title: EventName,
                    description: EventDescription,
                    imageUrl: imageUrl[0],
                    start: new Date(StartDate),
                    end: new Date(EndDate).setHours(new Date(EndDate).getHours() + 2),
                    ...rest,
                }));
                setEvents(newArrayOfObj)
                setisLoading(false)
                setResponsiveness();
                window.addEventListener('resize', () => setResponsiveness());
                return () => {
                    window.removeEventListener('resize', () => setResponsiveness());
                };
            }).catch(err => {
                //console.log(err)
            });

        // eslint-disable-next-line
    }, [])

    if (isLoading) {
        return (
            <div style={{ marginTop: 20, textAlign: 'center' }}>
                <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
                <LinearProgress />
            </div>
        );
    } else {
        return (

            <div style={{ height: '80vh', padding: '20px' }}>
                <div style={{ marginBottom: '10px', display: 'flex', justifyContent: 'center' }}>
                    <button className="create-event-button" style={{ color: config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor1, border: `1px solid ${config[process.env.REACT_APP_HOST_NAME].css.exploreButtonColor1}` }} onClick={() => { window.location.href = '/dashboard' }}>
                        <span className="create-event-button-text">Create Event</span>
                        <span className="create-event-button-icon"></span>
                    </button>
                </div>
                <Calendar
                    className="calendar-container"
                    localizer={localizer}
                    events={events}
                    startAccessor="start"
                    endAccessor="end"
                    defaultDate={moment().toDate()}
                    eventPropGetter={eventStyleGetter}
                    selectable={true}
                    views={calendarViews}
                    onSelectEvent={handleSelectEvent}
                    showMultiDayTimes={false}
                />
                {selectedEvent && (
                    <div className="popup">
                        <EventDetailsPopup event={selectedEvent} onJoinEvent={handleJoinEvent} mobileView={mobileView} />
                    </div>
                )}
            </div>
        );
    }
};

export default EventCalendar;
